import { render } from "./DepartmentTagList.vue?vue&type=template&id=86cb135a"
import script from "./DepartmentTagList.vue?vue&type=script&lang=js"
export * from "./DepartmentTagList.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__